import { useState, useRef, useEffect, useCallback } from 'react'
import './Chatbot.css'

// ── Base de connaissances enrichie ────────────────────────────────────────────
const KB = [
  {
    keys: ['bonjour','salut','hello','hey','bonsoir','bjr','coucou'],
    reply: "Bonjour ! 👋 Je suis PetBot, l'assistant d'Animaux pour Adoption de la France. Je peux vous aider à trouver votre compagnon idéal, répondre à vos questions sur la livraison, les paiements ou encore l'adoption. Par où commencer ?",
    suggestions: ['Voir les animaux', 'Comment adopter ?', 'Livraison ?']
  },
  {
    keys: ['chien','chiot','berger','golden','husky','bulldog','labrador','collie','spitz','cavalier','doberman','rottweiler','malinois','setter'],
    reply: "🐕 **Nos chiens disponibles :**\n• Berger Allemand — 850 €\n• Golden Retriever — 950 €\n• Husky Sibérien — 800 €\n• Bouledogue Français — 2 200 €\n• Labrador Retriever — 900 €\n\nTous sont vaccinés, pucés et livrés avec carnet de santé. Quelle race vous intéresse ?",
    suggestions: ['Livraison chiens ?', 'Documents fournis ?', 'Paiement ?']
  },
  {
    keys: ['chat','chaton','maine','bengal','ragdoll','british','persan','siamois','angora','abyssin'],
    reply: "🐱 **Nos chats disponibles :**\n• Maine Coon — 900 €\n• Bengal — 650 €\n• Ragdoll — 1 100 €\n• British Shorthair — 750 €\n• Persan — 800 €\n\nCertificats LOOF disponibles sur demande. Un chaton en particulier vous attire ?",
    suggestions: ['Livraison chats ?', 'Certificat LOOF ?', 'Paiement ?']
  },
  {
    keys: ['oiseau','perroquet','gris','gabon','conure','cacatoès','calopsitte','amazone','ara'],
    reply: "🦜 **Nos oiseaux disponibles :**\n• Gris du Gabon (élevé à la main) — 1 400 €\n• Conure Soleil — 380 €\n\nNos perroquets sont bagués et livrés avec leur carnet de santé. Des questions sur ces oiseaux ?",
    suggestions: ['Transport oiseaux ?', 'Paiement ?', 'Voir tous les animaux']
  },
  {
    keys: ['reptile','dragon','gecko','serpent','python','tortue','iguane','lézard','caméléon'],
    reply: "🦎 **Nos reptiles :**\n• Dragon Barbu — 180 € (idéal débutants)\n\nD'autres reptiles arrivent prochainement. Souhaitez-vous être notifié des nouvelles arrivées ?",
    suggestions: ['Comment adopter ?', 'Livraison ?', 'Paiement ?']
  },
  {
    keys: ['lapin','bélier','angora','cobaye','cochon d\'inde','rongeur','hamster'],
    reply: "🐰 **Petits animaux disponibles :**\n• Lapin Bélier Nain — 95 € (vacciné, câlin)\n\nParfaits pour les appartements et les familles avec enfants !",
    suggestions: ['Livraison lapin ?', 'Paiement ?', 'Autres animaux ?']
  },
  {
    keys: ['poisson','koï','aquarium','betta','guppy','discus'],
    reply: "🐠 **Nos poissons :**\n• Carpe Koï de qualité exposition — 220 €\n\nGarantie d'arrivée vivante sur chaque envoi. Transport sécurisé en oxygène.",
    suggestions: ['Transport poissons ?', 'Paiement ?']
  },
  {
    keys: ['livraison','expédition','transport','délai','envoi','shipping','voyage','déplacement'],
    reply: "🚚 **Notre service de livraison :**\n• Livraison dans 60+ pays\n• Incluse dans le prix de vente\n• Délais : 3 à 7 jours selon destination\n• Transport sécurisé & réfrigéré si nécessaire\n• Garantie arrivée en vie sur chaque envoi\n• Suivi en temps réel disponible\n\nVotre animal voyage dans des conditions optimales de confort.",
    suggestions: ['Documents requis ?', 'Santé des animaux ?', 'Paiement ?']
  },
  {
    keys: ['paiement','prix','coût','payer','carte','paypal','virement','acompte','remise','réduction','promotion'],
    reply: "💳 **Modes de paiement acceptés :**\n• Carte bancaire (Visa / Mastercard)\n• PayPal\n• Apple Pay & Google Pay\n• Virement bancaire\n\nTous les paiements sont 100% sécurisés par chiffrement SSL. Un acompte peut être demandé pour réserver un animal.",
    suggestions: ['Prix des animaux ?', 'Livraison ?', 'Comment adopter ?']
  },
  {
    keys: ['vaccin','santé','vétérinaire','certificat','pedigree','lof','loof','puce','tatouage','vermifuge','traitement'],
    reply: "🏥 **Santé & documents :**\n• Vaccinés & vermifugés\n• Examen vétérinaire complet\n• Carnet de santé inclus\n• Puce électronique ou tatouage\n• Pédigrées (LOF, LOOF, TICA) sur demande\n• Passeport européen pour les envois UE\n\nTous nos animaux sont en parfaite santé avant expédition.",
    suggestions: ['Livraison ?', 'Paiement ?', 'Comment adopter ?']
  },
  {
    keys: ['adopter','adoption','processus','étapes','comment','procédure','démarche'],
    reply: "📋 **Comment adopter chez nous :**\n1. Parcourez nos annonces et choisissez votre animal\n2. Créez un compte sur la plateforme\n3. Contactez l'éleveur via le chat\n4. Finalisez le paiement sécurisé\n5. Signez le contrat de cession\n6. Votre animal est livré sous 3–7 jours\n\nNos conseillers vous accompagnent à chaque étape. 🐾",
    suggestions: ['Paiement ?', 'Livraison ?', 'Documents requis ?']
  },
  {
    keys: ['contacter','vendeur','éleveur','annonceur','téléphone','email','message','chat'],
    reply: "💬 Sur chaque annonce, le bouton **« Contacter l'annonceur »** vous permet d'envoyer un message directement à l'éleveur. Vous pouvez aussi utiliser notre messagerie interne une fois connecté.",
    suggestions: ['Créer un compte ?', 'Comment adopter ?', 'Livraison ?']
  },
  {
    keys: ['compte','connexion','inscription','enregistrer','login','profil','mot de passe'],
    reply: "🔐 **Votre espace personnel :**\nCliquez sur **« Connexion »** dans la navigation pour créer votre compte ou vous connecter. C'est gratuit ! Depuis votre espace, vous pouvez :\n• Gérer vos achats & favoris\n• Accéder à vos documents\n• Suivre vos livraisons\n• Contacter les éleveurs",
    suggestions: ['Comment adopter ?', 'Paiement ?', 'Mes favoris ?']
  },
  {
    keys: ['garantie','retour','problème','plainte','réclamation','remboursement'],
    reply: "🛡️ **Nos garanties :**\n• Garantie arrivée en vie sur chaque animal\n• Remboursement intégral en cas de problème à la livraison\n• Service après-vente disponible 7j/7\n• Certificat vétérinaire à l'arrivée\n\nEn cas de problème, contactez-nous immédiatement via la messagerie.",
    suggestions: ['Contacter un conseiller ?', 'Paiement ?', 'Livraison ?']
  },
  {
    keys: ['merci','super','parfait','excellent','top','génial','bien','cool','nickel','impeccable'],
    reply: "Avec plaisir ! 😊 C'est toujours un bonheur d'aider à trouver un nouveau compagnon. N'hésitez pas si vous avez d'autres questions. Bonne adoption ! 🐾",
    suggestions: ['Voir les animaux', 'Comment adopter ?']
  },
  {
    keys: ['favori','favoris','sauvegarder','enregistrer annonce','liste'],
    reply: "❤️ Pour sauvegarder une annonce dans vos favoris, cliquez sur l'icône cœur sur la fiche de l'animal. Retrouvez tous vos favoris dans **Mes favoris** depuis votre espace personnel.",
    suggestions: ['Créer un compte ?', 'Comment adopter ?']
  },
  {
    keys: ['suivi','tracking','où est','localisation','colis','commande'],
    reply: "📍 **Suivi de votre commande :**\nUne fois votre animal expédié, vous recevez un email avec le lien de suivi en temps réel. Vous pouvez aussi consulter **Mes transports** dans votre espace personnel.",
    suggestions: ['Livraison ?', 'Mon compte ?']
  },
]

const DEFAULT_SUGGESTIONS = ['Chiens disponibles ?', 'Comment adopter ?', 'Livraison ?', 'Paiement ?']

function getBotResponse(msg) {
  const m = msg.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
  for (const item of KB) {
    const normalized = item.keys.map(k => k.normalize('NFD').replace(/[\u0300-\u036f]/g, ''))
    if (normalized.some(k => m.includes(k))) {
      return { reply: item.reply, suggestions: item.suggestions || DEFAULT_SUGGESTIONS }
    }
  }
  return {
    reply: "Je n'ai pas bien compris votre question 🤔\n\nJe peux vous renseigner sur :\n• Nos animaux disponibles (chiens, chats, oiseaux…)\n• La livraison & le transport\n• Les paiements\n• Le processus d'adoption\n• La santé & les documents",
    suggestions: DEFAULT_SUGGESTIONS
  }
}

// Rendu du texte avec **gras** et \n
function BubbleText({ text }) {
  const lines = text.split('\n')
  return (
    <span>
      {lines.map((line, li) => {
        const parts = line.split(/\*\*(.+?)\*\*/g)
        return (
          <span key={li}>
            {parts.map((p, pi) => pi % 2 === 1 ? <strong key={pi}>{p}</strong> : p)}
            {li < lines.length - 1 && <br />}
          </span>
        )
      })}
    </span>
  )
}

// Animation points de frappe
function TypingDots() {
  return (
    <div className="chatbot-typing">
      <span /><span /><span />
    </div>
  )
}

export default function Chatbot() {
  const [open, setOpen]           = useState(false)
  const [messages, setMessages]   = useState([
    {
      role: 'bot',
      text: "Bonjour ! 👋 Je suis **PetBot**, votre assistant Animaux pour Adoption.\n\nComment puis-je vous aider aujourd'hui ?",
      time: 'Maintenant',
      suggestions: DEFAULT_SUGGESTIONS
    }
  ])
  const [input, setInput]         = useState('')
  const [typing, setTyping]       = useState(false)
  const [suggestions, setSuggestions] = useState(DEFAULT_SUGGESTIONS)
  const [unread, setUnread]       = useState(0)
  const endRef   = useRef(null)
  const inputRef = useRef(null)

  useEffect(() => {
    if (open) {
      endRef.current?.scrollIntoView({ behavior: 'smooth' })
      inputRef.current?.focus()
      setUnread(0)
    }
  }, [messages, open])

  const sendMessage = useCallback((text) => {
    if (!text.trim() || typing) return
    const now = new Date().toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })
    setMessages(m => [...m, { role: 'user', text, time: now }])
    setInput('')
    setTyping(true)
    setSuggestions([])

    const delay = 700 + Math.min(text.length * 15, 800)
    setTimeout(() => {
      const { reply, suggestions: sugg } = getBotResponse(text)
      const botTime = new Date().toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })
      setMessages(m => [...m, { role: 'bot', text: reply, time: botTime, suggestions: sugg }])
      setSuggestions(sugg)
      setTyping(false)
      if (!open) setUnread(u => u + 1)
    }, delay)
  }, [typing, open])

  const handleOpen = () => { setOpen(o => !o); setUnread(0) }

  return (
    <>
      {/* Bouton flottant */}
      <button className="chatbot-fab" onClick={handleOpen} title="Chat avec PetBot" aria-label="Ouvrir le chat">
        {open ? (
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><path d="M18 6L6 18M6 6l12 12"/></svg>
        ) : (
          <>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
            </svg>
            {unread > 0 && <span className="chatbot-fab-badge">{unread}</span>}
          </>
        )}
      </button>

      {/* Fenêtre de chat */}
      {open && (
        <div className="chatbot-window" role="dialog" aria-label="Chat PetBot">

          {/* Header */}
          <div className="chatbot-header">
            <div className="chatbot-header-avatar">
              <img src={require('../../assets/monlogo.jpeg')} alt="Logo" className="chatbot-header-logo" onError={e => { e.target.style.display = 'none' }}/>
            </div>
            <div className="chatbot-header-info">
              <div className="chatbot-header-name">PetBot</div>
              <div className="chatbot-header-status">
                <span className="chatbot-status-dot" />
                {typing ? 'En train d\'écrire…' : 'En ligne — répond instantanément'}
              </div>
            </div>
            <button className="chatbot-header-close" onClick={() => setOpen(false)} aria-label="Fermer">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><path d="M18 6L6 18M6 6l12 12"/></svg>
            </button>
          </div>

          {/* Messages */}
          <div className="chatbot-messages" role="log" aria-live="polite">
            {messages.map((m, i) => (
              <div key={i} className={`chatbot-msg ${m.role}`}>
                {m.role === 'bot' && (
                  <div className="chatbot-msg-avatar">🐾</div>
                )}
                <div className="chatbot-msg-content">
                  <div className="chatbot-msg-bubble">
                    <BubbleText text={m.text} />
                  </div>
                  <div className="chatbot-msg-time">{m.time}</div>
                </div>
              </div>
            ))}

            {/* Animation de frappe */}
            {typing && (
              <div className="chatbot-msg bot">
                <div className="chatbot-msg-avatar">🐾</div>
                <div className="chatbot-msg-content">
                  <div className="chatbot-msg-bubble">
                    <TypingDots />
                  </div>
                </div>
              </div>
            )}
            <div ref={endRef} />
          </div>

          {/* Suggestions contextuelles */}
          {suggestions.length > 0 && !typing && (
            <div className="chatbot-suggestions">
              {suggestions.map(s => (
                <button key={s} className="chatbot-sugg" onClick={() => sendMessage(s)}>{s}</button>
              ))}
            </div>
          )}

          {/* Input */}
          <div className="chatbot-input-row">
            <input
              ref={inputRef}
              className="chatbot-input"
              placeholder="Posez votre question…"
              value={input}
              onChange={e => setInput(e.target.value)}
              onKeyDown={e => e.key === 'Enter' && !e.shiftKey && sendMessage(input)}
              disabled={typing}
              aria-label="Message"
            />
            <button className="chatbot-send" onClick={() => sendMessage(input)} disabled={typing || !input.trim()} aria-label="Envoyer">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <line x1="22" y1="2" x2="11" y2="13"/>
                <polygon points="22 2 15 22 11 13 2 9 22 2"/>
              </svg>
            </button>
          </div>
        </div>
      )}
    </>
  )
}